import React, { useState } from 'react';
import styles from '../../styles/hardware/hardware.module.css';
import ReactTyped from 'react-typed';
import Image from 'next/image';
import { AdvanceAnalyticsBanner, AndroidPOSBenifits, BlackCustomButton, MarqueeComponentHomePage, TransparentCustomButton, WhiteCustomButton } from '../qbStrap';
import ThreeStepForm from '../common/ThreeStepForm';
import TestimonialSection from '../common/TestimonialSection';
import { ClientsArr1, paymentDevies, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import TrustFactor from '../common/TrustFactor';
import FrequentQuestions from '../homePage/FrequentQuestions';
import { paymentFaq } from '@/constants/industry';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import Link from 'next/link';
import { LuArrowUpRight } from "react-icons/lu";
import VerificationPopup from '../modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../language/ENGLISH.json';

const DesktopPayment = () => {
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <h1>
                        <span className={styles.small_black_text}>POS Payment Integration</span><br />
                        <span className={styles.black_text}>Facilitating </span><br /> <span className={styles.blue_text}><ReactTyped strings={["Cards", "UPI", "Cash", "Vouchers"]} typeSpeed={200} loop /></span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster takes you into the world of integrated payment solutions from the leading fintech brands tailored for your business.</p>
                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try it Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img_container}>
                    <div className={styles.hero_img}><Image src="/assets/payment-partners/hero-img.webp" alt="hardware hero img" fill /></div>
                </div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.all_devices} style={{ height: "62rem" }}>
                <div className={styles.stack1} style={{ height: "60rem" }}>
                    <div className={styles.choosing_section} style={{ width: "100%" }}>
                        <h3 style={{ width: "100%", textAlign: "center" }}>Reliable, Fast & Secure Payment Brands</h3>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "2.5rem" }}>
                            {
                                paymentDevies?.map((ele, idx) => {
                                    return (
                                        <div className={styles.hardware_device}>
                                            <div className={styles.hardware_device_img} style={{ height: ele?.height, width: ele?.width }}><Image src={ele?.image} alt={ele?.altText} fill /></div>
                                            <Link href={ele?.link} className={styles.navigtaion_link}>Learn More &nbsp;<LuArrowUpRight /></Link>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.stack2}></div>
                <div className={styles.stack3}></div>
            </div>

            <AndroidPOSBenifits setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.good_hardware}>
                <div className={styles.text_section}>
                    <h4>Why Does Your Business Need a Payment Integrated POS?</h4>
                    <ul className={styles.list_container}>
                        <li>A leading payment integration can help you streamline your payment processes, making it quicker and easier for customers to make purchases in your retail store.</li>
                        <li>You can offer a wider range of payment options to your customers. This can help you attract more customers and increase your sales revenue.</li>
                        <li>Having a leading payment integration in place can also help you to improve the security of your payment transactions. </li>
                    </ul>
                </div>
                <div className={styles.hardware_img}><Image src="/assets/hardware/hardware.svg" alt="Android POS Software" fill /></div>
            </div>

            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />

            <div className={styles.why_qbPOS}>
                <div className={styles.text_section}>
                    <h4 className={styles.why_qbPOS_heading}>Accept Payments as You Like, With QueueBuster POS</h4>
                    <ul className={styles.list_container}>
                        <li><b>Flexibility:</b> QueueBuster POS offers flexible payment options, allowing you to accept payments in a way that suits your business needs.</li>
                        <li><b>Versatility:</b> Get used to a seamless checkout experience for your customers, which can help increase repeat customers and brand presence.</li>
                        <li><b>User-Friendly:</b> QB POS billing software is designed to be user-friendly, making it easy for you and your staff to operate, reducing errors and delays.</li>
                        <li><b>Analytics:</b> Get access to real-time reporting and analytics, which can help you make informed decisions about your business and identify areas for improvement.</li>
                    </ul>
                </div>
                <div className={styles.qbPOS_device}><Image src="/assets/hardware/why_qbPOS_device.webp" alt="Android POS Software" fill /></div>
            </div>

            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={paymentFaq} heading={"FAQs for Hardware Compatibility of QueueBuster POS"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopPayment